<section @displayContent>
  <img src="/assets/images/logo/duoges.png" alt="Duoges" />
  <router-outlet></router-outlet>
</section>
